<template>
<div>
    <b-modal v-model="showModal" :can-cancel="[]" has-modal-card trap-focus full-screen>
        <div class="modal-card " style="width: auto">
            <header class="modal-card-head">
                <img class="modal-card-logo" src="https://i.postimg.cc/nLmT08ZT/cz-M6-Ly9t-ZWRp-YS1wcml2-YXRl-Lm-Nhbn-Zh-Lm-Nvb-S9-WWVZGSS9-NQUZy-YXl-WWVZGSS8x-L3-Auc3-Zn.png" alt="">
                <p class="modal-card-title">{{ modalTitle }}</p>
            </header>

            <section class="modal-card-body columns is-full" v-if="tutorialStep === 1">
                <div class="tutorial-list">
                    <div v-for="(tutorial, index) in tutorialData" :key="index" @click="setTutorial(tutorial.step, false)" :class="{'selected': videoTutorialStep === tutorial.step, 'disabled': maxStepReached < tutorial.step}">
                        <b-icon icon="play-circle-outline" size="is-small" :type="{'is-success': videoTutorialStep > tutorial.step}"></b-icon>
                        <span class="tutorial-title">{{ tutorial.title }}</span>
                        <span class="video-duration">{{ tutorial.duration }}</span>
                    </div>
                </div>

                <div class="tutorial-display" v-if="videoTutorialStep === currentTutorial.step">
                    <h5 class="tutorial-display__title">{{ currentTutorial.title }}
                            <b-button label="Next" :disabled="completedVideo < currentTutorial.step" type="is-primary" @click="askTutorialQuestion(currentTutorial.step)" />
                            <b-button v-if="personalInformation.tutorialMark >= 0" label="Retake test" type="is-primary" @click="rewatchTutorials(true)" />
                        </h5>
                    <video-player class="video-player-box" ref="videoPlayer" customEventName="customstatechangedeventname" :options="playerOptions" @ended="completedVideo = currentTutorial.step">
                    </video-player>

                    <div class="tutorial-display-text">
                        <span> Transcript </span>
                        <p v-html="currentTutorial.transcript"></p>
                    </div>
                </div>

            </section>

            <form v-if="tutorialStep === 2" class="modal-card-body tutorial-modal-card-body" @submit.prevent="handleQuestionValidator" action="">
                <section class="columns is-full">
                    <div class="welcome-overlay" v-if="showQuestionWelcomeScreen && personalInformation.tutorialMark === -1">
                        <img src="https://ask33.co.uk/assets/img/logo_short.png" alt="">
                        <p>Congratulations on completing the training, <b>{{ currentUser.username }}</b></p>
                        <p> Now we'll see what you managed to learn. Click on the button below to access the test</p>
                        <b-button label="Start" type="is-primary" @click="showQuestionWelcomeScreen = false" />
                    </div>

                    <div class="welcome-overlay" v-if="showQuestionWelcomeScreen && personalInformation.tutorialMark < 80 && personalInformation.tutorialMark !== -1">
                        <img src="https://ask33.co.uk/assets/img/logo_short.png" alt="">
                        <p>Sorry <b>{{ currentUser.username }}</b></p>
                        <p> You didn't manage to get a score of over 80 points, you only got <b>{{ personalInformation.tutorialMark }}</b></p>
                        <b-button label="Take test" type="is-primary" @click="showQuestionWelcomeScreen = false" />
                        <b-button label="Rewatch videos" type="is-primary" @click="rewatchTutorials(false)" />
                    </div>

                    <div class="welcome-overlay" v-if="showQuestionWelcomeScreen && personalInformation.tutorialMark >= 80">
                        <img src="https://ask33.co.uk/assets/img/logo_short.png" alt="">
                        <p>Congratulations <b>{{ currentUser.username }}</b></p>
                        <p> You managed to get a score of over 80 points,<b>{{ personalInformation.tutorialMark }} to be exact</b></p>
                        <b-button label="Start" type="is-primary" @click="triggerValidExam()" />
                    </div>

                    <div v-for="(question, index) in finalQuestions" :key="index" class="column is-full">
                        <b-field :label="question.question" :type="{'is-danger': errors.has(`Question no.${question.order.toString()}`)}" :message="errors.first(`Question no.${question.order.toString()}`)">

                            <div v-if="question.type === 'radio'">
                                <b-radio v-model="finalQuestions[index].answer" :name="`Question no.${question.order.toString()}`" native-value="True" v-validate="'required'">
                                    True
                                </b-radio>
                                <b-radio v-model="finalQuestions[index].answer" :name="`Question no.${question.order.toString()}`" native-value="False" v-validate="'required'">
                                    False
                                </b-radio>
                            </div>

                            <div v-if="question.type === 'single-select' || question.type === 'multi-select'">

                                <b-checkbox v-for="(option, i) in question.options" v-model="finalQuestions[index].answer" :name="`Question no.${question.order.toString()}`" :key="i" :native-value="option" v-validate="'required'" @click.native="changeSelectValue(index, question.type)">
                                    {{ option }}
                                </b-checkbox>

                            </div>

                            <div v-if="question.type === 'text'">
                                <b-input v-model="finalQuestions[index].answer" :name="`Question no.${question.order.toString()}`" type="text" v-validate="'required'"></b-input>
                            </div>

                        </b-field>
                    </div>
                </section>

                <footer class="tutorial-footer">
                    <button type="submit" class="button is-primary"><span>Validate</span></button>
                </footer>
            </form>

            <form v-if="tutorialStep === 3" class="modal-card-body tutorial-modal-card-body" @submit.prevent="handlePersonalInfoValidator" action="">
                <section class="columns is-full">
                    <div class="welcome-overlay" v-if="showWelcomeScreen">
                        <img src="https://ask33.co.uk/assets/img/logo_short.png" alt="">
                        <p>Welcome <b>{{ currentUser.username }}</b></p>
                        <p> Now, let's fill in some information </p>
                        <b-button label="Start" type="is-primary" @click="showWelcomeScreen = false" />
                    </div>

                    <b-field label="First name" class="column is-one-third" :type="{'is-danger': errors.has('first_name')}" :message="errors.first('first_name')">
                        <b-input v-model="personalInformation.first_name" type="text" name="first_name" v-validate="'required'"></b-input>
                    </b-field>

                    <b-field label="Last name / Family name" class="column is-one-third" :type="{'is-danger': errors.has('last_name')}" :message="errors.first('last_name')">
                        <b-input v-model="personalInformation.last_name" type="text" name="last_name" v-validate="'required'"></b-input>
                    </b-field>

                    <b-field label="Date of birth" class="column is-half-third" :type="{'is-danger': errors.has('date_of_birth')}" :message="errors.first('date_of_birth')">
                        <b-datepicker name="date_of_birth" required editable v-model="personalInformation.date_of_birth" locale="en-GB" :show-week-number="true" v-validate="'required'" placeholder="Click to select..." icon="calendar-today" :icon-right="personalInformation.date_of_birth ? 'close-circle' : ''" icon-right-clickable @icon-right-click="clearDate('date_of_birth')" trap-focus>
                        </b-datepicker>
                    </b-field>

                    <b-field label="Gender" class="column is-half-third" :addons="false" :type="{'is-danger': errors.has('gender')}" :message="errors.first('gender')">
                        <b-select v-model="personalInformation.gender" placeholder="Select a gender" required>
                            <option v-for="option in genderOptions" :value="option" :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field label="Email address" class="column is-one-third" :type="errors.has('email') ? 'is-danger': ''" :message="errors.has('email') ? errors.first('email') : ''">
                        <b-input v-model="personalInformation.email" type="text" name="email" v-validate="'required|email'"></b-input>
                    </b-field>

                    <b-field label="Work Email address" class="column is-one-third" :type="errors.has('work_email') ? 'is-danger': ''" :message="errors.has('work_email') ? errors.first('work_email') : ''">
                        <b-input v-model="personalInformation.work_email" type="text" name="work_email" v-validate="'required|email'"></b-input>
                    </b-field>

                    <b-field label="Phone number" class="column is-one-third" :type="{'is-danger': errors.has('phone_number')}" :message="errors.first('phone_number')">
                        <b-input v-model="personalInformation.phone_number" type="text" name="phone_number" v-validate="'required|min:10|max:12'"></b-input>
                    </b-field>

                    <div class="columns column is-full">
                        <b-field label="UK Address" class="column is-one-third" :type="{'is-danger': errors.has('house_number')}" :message="errors.first('house_number')">
                            <b-input placeholder="House number" v-model="personalInformation.house_number" type="text" name="house_number" v-validate="'required'"></b-input>
                        </b-field>

                        <b-field label="Street" class="column is-one-third hide-label" :type="{'is-danger': errors.has('street_address')}" :message="errors.first('street_address')">
                            <b-input placeholder="Street" v-model="personalInformation.street_address" type="text" name="street_address" v-validate="'required'"></b-input>
                        </b-field>

                        <b-field label="City" class="column is-one-third hide-label" :type="{'is-danger': errors.has('city')}" :message="errors.first('city')">
                            <b-input placeholder="City" v-model="personalInformation.city" type="text" name="city" v-validate="'required'"></b-input>
                        </b-field>

                        <b-field label="Country" class="column is-one-third hide-label" :type="{'is-danger': errors.has('country')}" :message="errors.first('country')">
                            <b-autocomplete name="country" required placeholder="Country" v-validate="'required'" open-on-focus v-model="personalInformation.country" :data="filteredCountries('country')" icon="magnify" clearable @select="option => personalInformation.country = option">
                                <template #empty>No results found</template>
                            </b-autocomplete>
                        </b-field>

                        <b-field label="Zip code" class="column is-one-third hide-label" :type="{'is-danger': errors.has('zip_code')}" :message="errors.first('zip_code')">
                            <b-input v-validate="'required'" placeholder="Postcode" v-model="personalInformation.zip_code" type="text" name="zip_code"></b-input>
                        </b-field>
                    </div>

                    <b-field label="Team Leader" class="column is-one-third" :type="{'is-danger': errors.has('team_leader')}" :message="errors.first('team_leader')">
                        <b-autocomplete name="team_leader" required placeholder="Choose from the list or type name" v-validate="'required'" open-on-focus v-model="personalInformation.team_leader" :data="filteredUsers()" icon="magnify" clearable @select="option => personalInformation.team_leader = option">
                            <template #empty>No results found</template>
                        </b-autocomplete>
                    </b-field>

                    <b-field label="Start date" class="column is-one-third">
                        <b-datepicker name="start_date" required editable v-model="personalInformation.start_date" locale="en-GB" :show-week-number="true" placeholder="Day training was finished" icon="calendar-today" :icon-right="personalInformation.start_date ? 'close-circle' : ''" icon-right-clickable @icon-right-click="clearDate('start_date')" trap-focus>
                        </b-datepicker>
                    </b-field>
                </section>
                <footer class="tutorial-footer">
                    <button type="submit" class="button is-primary"><span>Validate</span></button>
                </footer>
            </form>

            <section class="modal-card-body tutorial-modal-card-body content" v-if="tutorialStep === 4">
                <h1 class="title">Job Description and Responsabilities</h1>
                <p>
                    As a Student Recruitment Agent at Ask33, you play a crucial role in facilitating the journey of prospective students aiming to pursue their education in the UK.
                </p>
                <b>
                    Responsabilities:
                </b>
                <ol type="1">
                    <li>
                        Use daily social media platforms to promote UK educational partner institutions and create content to attract and inform prospective students.
                    </li>
                    <li>
                        Provide personalized assistance to students by understanding their academic goals and tailoring advice accordingly
                    </li>
                    <li>
                        Assist students in completing application forms and submitting the necessary documentation and Keep up to date with the admission requirements of UK partner universities and guide students in selecting suitable courses and institutions.
                    </li>
                    <li>
                        Ensure all required documents are accurate, complete, and submitted within specified deadlines
                    </li>
                </ol>

                <b-field class="checkbox-accept-tutorial">
                    <b-checkbox size="is-medium" v-model="personalInformation.agreedToJD" :type="personalInformation.agreedToJD ? 'is-success' : 'is-info'">
                        I, {{ currentUser.username }} , understand that by checking this box I am agreeing to complete these activities on a daily basis
                    </b-checkbox>
                </b-field>

                <footer class="tutorial-footer">
                    <b-button :disabled="!personalInformation.agreedToJD" @click="nextAgree()" class="next-btn is-primary">Next</b-button>
                </footer>
            </section>

            <section class="modal-card-body tutorial-modal-card-body content" v-if="tutorialStep === 5">
                <h1 class="title">Payment</h1>

                <div class="row columns">
                    <div class="col-md-12 col-lg-6 col-sm-12">
                        <p>
                            Once your student gets approval for funding from StudentFinance you receive £100 up-front, and the rest of the commission money you will receive once Student Finance pays the university so the Agency can receive commission for the students, usually taking between 3 and 5 months.
                        </p>
                        <b-field class="checkbox-accept-tutorial">
                            <b-checkbox size="is-medium" v-model="personalInformation.agreedPayment" :type="personalInformation.agreedPayment ? 'is-success' : 'is-info'">
                                I, {{ currentUser.username }} , understand that by checking this box, I agree to this commission scheme and that this commission scheme may change at any time.
                            </b-checkbox>
                        </b-field>

                        <b-button :disabled="!personalInformation.agreedPayment" @click="nextAgree()" class="next-btn is-primary">Next</b-button>
                    </div>

                    <div class="col-md-12 col-lg-6 col-sm-12 image-background___tutorial" :style="{'background-image': 'url(' + require('@/assets/media/payment.jpg') + ')'}"></div>
                </div>
            </section>

            <section class="modal-card-body tutorial-modal-card-body content" v-if="tutorialStep === 6">
                <h1 class="title">Confidentiality and Non-Disclosure of Student personal data:</h1>
                <ol type="1">
                    <li>
                        Students' personal data should only be collected for the purpose of enrolment at the university and not further processed in a way incompatible with those purposes
                    </li>
                    <li>
                        Only the minimum amount of personal data necessary for the application to the university should be processed
                    </li>
                    <li>
                        The obligation to report certain types of personal data breaches to the direct supervisor within 24 hours of becoming aware of the data breach, unless the breach is unlikely to result in a risk to the rights and freedoms of future or current students
                    </li>
                </ol>

                <b-field class="checkbox-accept-tutorial">
                    <b-checkbox size="is-medium" v-model="personalInformation.agreedNCDStudent" :type="personalInformation.agreedNCDStudent ? 'is-success' : 'is-info'">
                        I, {{ currentUser.username }} , understand that by ticking this box, I agree to the processing and handling of students' personal data, and any breach of this may have legal consequences
                    </b-checkbox>
                </b-field>

                <footer class="tutorial-footer">
                    <b-button :disabled="!personalInformation.agreedNCDStudent" @click="nextAgree()" class="next-btn is-primary">Next</b-button>
                </footer>
            </section>

            <section class="modal-card-body tutorial-modal-card-body content" v-if="tutorialStep === 7">
                <h1 class="title">Confidentiality and Non-Disclosure of internal procedures:</h1>
                <ol type="1">
                    <li>
                        <b>Definition of confidential information:</b>
                        <br>
                        For the purposes of this Agreement, "Confidential Information" includes, but is not limited to, all non-public information, documents, procedures, methodologies, updates and other internal information relating to the admissions process of UK universities, whether disclosed in writing, orally or by any other means.
                    </li>

                    <li>
                        <b>Confidentiality obligations</b>
                        <br>
                        The Receiving Party (the "Agent") acknowledges and agrees that it will keep confidential and will not disclose, reproduce, distribute or use, directly or indirectly, any Confidential Information for any purpose other than to carry out its obligations under this Agreement.
                    </li>

                    <li>
                        <b>Exceptions</b>
                        <br>
                        The confidentiality obligations set forth in this clause do not apply to information that:<br>
                        a. Is or becomes publicly available without breach of this Agreement;<br>
                        b. Is lawfully received by the recipient from a third party without an obligation of confidentiality;<br>
                        c. Is independently developed by the recipient without reference to or reliance on Confidential Information
                    </li>

                    <li>
                        <b>Use of Confidential Information:</b>
                        <br>
                        Recipient agrees to use the Confidential Information solely for the purpose of the admissions process at UK universities as described in this Agreement. Any other use requires the prior written consent of the disclosing party (hereinafter referred to as the "Ask33 agency").
                    </li>

                    <li>
                        <b>Duration of Confidentiality</b>
                        <br>
                        Confidentiality obligations will survive termination of this Agreement and will continue indefinitely
                    </li>

                    <li>
                        <b>Return or Destruction of Confidential Information</b>
                        <br>
                        Upon termination of this Agreement or at the written request of Discloser, Agent shall promptly return or, at Discloser's option, destroy all copies of Confidential Information in its possession or control
                    </li>

                    <li>
                        <b>Permitted Disclosures</b>
                        <br>
                        Recipient may disclose Confidential Information to its employees, agents or representatives who have a need to know for purposes of this Agreement, provided that such persons are bound by written confidentiality obligations at least as restrictive as those set forth herein
                    </li>

                    <li>
                        <b>Governing Law</b>
                        <br>
                        This confidentiality clause shall be governed by and construed in accordance with the laws of the United Kingdom
                    </li>
                </ol>

                <b-field class="checkbox-accept-tutorial">
                    <b-checkbox size="is-medium" v-model="personalInformation.agreedNCDPersonal" :type="personalInformation.agreedNCDPersonal ? 'is-success' : 'is-info'">
                        I, {{ currentUser.username }} , understand that by checking this box, I agree to the processing and handling of internal procedures, and any violation of these may have legal repercussions
                    </b-checkbox>
                </b-field>

                <footer class="tutorial-footer">
                    <b-button :disabled="!personalInformation.agreedNCDPersonal" @click="nextAgree()" class="next-btn is-primary">Next</b-button>
                </footer>
            </section>

            <section class="modal-card-body tutorial-modal-card-body content" v-if="tutorialStep === 8">
                <h1 class="title">Terms of Termination</h1>

                <p>
                    The collaboration can be terminated at any time by either party, <br>
                    The agent is obliged to notify his supervisor directly by any method.
                </p>

                <b-field class="checkbox-accept-tutorial">
                    <b-checkbox size="is-medium" v-model="personalInformation.agreedTermination" :type="personalInformation.agreedTermination ? 'is-success' : 'is-info'">
                        I, {{ currentUser.username }} , understand that by checking this box, I agree that this collaboration may be terminated at any time with proper notice
                    </b-checkbox>
                </b-field>

                <footer class="tutorial-footer">
                    <b-button :disabled="!personalInformation.agreedTermination" @click="nextAgree()" class="next-btn is-primary">Next</b-button>
                </footer>
            </section>

            <form v-if="tutorialStep === 9" class="modal-card-body tutorial-modal-card-body" @submit.prevent="handlePersonalInfoValidator" action="">
                <section class="columns is-full">

                    <b-field label="National Insurance No" class="column is-one-third" :type="{'is-danger': errors.has('national_ins_no')}" :message="errors.first('national_ins_no')">
                        <b-input v-model="personalInformation.financial.national_ins_no" type="text" name="national_ins_no" v-validate="'required'"></b-input>
                    </b-field>

                    <b-field label="UK Settlement status" class="column is-one-third" :type="{'is-danger': errors.has('uk_settlement_status')}" :message="errors.first('uk_settlement_status')">
                        <b-input v-model="personalInformation.financial.uk_settlement_status" type="text" name="uk_settlement_status" v-validate="'required'"></b-input>
                    </b-field>

                    <b-field label="Share code" class="column is-one-third" :type="{'is-danger': errors.has('share_code')}" :message="errors.first('share_code')">
                        <b-input v-model="personalInformation.financial.share_code" type="text" name="share_code" v-validate="'required'"></b-input>
                    </b-field>

                    <b-field label="Are you self-employed now?" class="column is-one-third" :addons="false" :type="{'is-danger': errors.has('self_employed')}" :message="errors.first('self_employed')">
                        <b-radio v-model="personalInformation.financial.self_employed" name="self_employed" native-value="Yes" v-validate="'required'">
                            Yes
                        </b-radio>
                        <b-radio v-model="personalInformation.financial.self_employed" name="self_employed" native-value="No" v-validate="'required'">
                            No
                        </b-radio>

                        <b-notification v-if="personalInformation.financial.self_employed === 'No'" type="is-danger" class="self-employed-warning" aria-close-label="Close notification" role="alert">
                            Apply for UTR no. - you have <b>one month</b> from the start date
                        </b-notification>
                    </b-field>

                    <b-field v-if="personalInformation.financial.self_employed === 'Yes'" label="Enter your UTR no." class="column is-two-third" :type="{'is-danger': errors.has('utr_no')}" :message="errors.first('utr_no')">
                        <b-input v-model="personalInformation.financial.utr_no" type="text" name="utr_no" v-validate="'required'"></b-input>
                    </b-field>

                    <div class="content column is-full">
                        <b>Bank Details(optional)</b>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Can be completed later</span>
                    </div>

                    <b-field label="Account name" class="column is-one-third">
                        <b-input v-model="personalInformation.financial.account_name" type="text" name="account_name"></b-input>
                    </b-field>

                    <b-field label="Account no." class="column is-one-third">
                        <b-input v-model="personalInformation.financial.account_no" type="text" name="account_no"></b-input>
                    </b-field>

                    <b-field label="Sort code" class="column is-one-third">
                        <b-input v-model="personalInformation.financial.short_code" type="text" name="short_code"></b-input>
                    </b-field>

                </section>
                <footer class="tutorial-footer">
                    <button type="submit" class="button is-primary"><span>Validate</span></button>
                </footer>
            </form>
        </div>

        <b-button @click.prevent="logOut()" type="is-primary" class="mt-2 logout-button-setup">LogOut</b-button>
    </b-modal>

    <b-sidebar type="is-light" v-if="!showWelcomeScreen" fullheight v-model="showSidebar" open mobile position="static" class="tutorial-sidebar">
        <div class="p-1">
            <b-menu>
                <b-menu-list label="">
                    <b-menu-item v-for="(item, i) in sidebarTutorialList" :key="i" :active="item.order === tutorialStep" :label="item.label" :disabled="maxTutorialStepReached < item.order" @click="tutorialStep = item.order">
                    </b-menu-item>
                </b-menu-list>
            </b-menu>
        </div>
    </b-sidebar>

    <b-modal v-model="currentTutorialQuestion.show" :can-cancel="[]">
        <b-field :label="currentTutorialQuestion.question" class="column is-full">
            <b-radio v-model="currentTutorialQuestion.answer" name="answer_true" native-value="True">
                True
            </b-radio>
            <b-radio v-model="currentTutorialQuestion.answer" name="answer_false" native-value="False">
                False
            </b-radio>
        </b-field>

        <b-button @click="validateAnswer()" v-if="!currentTutorialQuestion.type">
            Validate
        </b-button>
        <div v-else>
            <h6 v-if="currentTutorialQuestion.type === 'text-is-success'" class="text-is-success">Congratulations</h6>
            <p v-else class="text-is-danger" style="margin-bottom:15px"> Sorry, the correct answer was {{ currentTutorialQuestion.correctAnswer }}</p>
            <b-button v-if="currentTutorialQuestion.type === 'text-is-success'" @click="setTutorial(currentTutorialQuestion.step + 1, true)">
                Next question
            </b-button>
            <b-button v-else @click="rewatchVideo()">
                Rewatch video
            </b-button>
        </div>
    </b-modal>
</div>
</template>

<script>
require('videojs-youtube'); // add any plugin first and then
import {
    countryList,
    genderOptions
} from '../../models/static'
import {
    tutorialData,
    tutorialQuestions
} from '../../models/tutorial';
import UserService from '../../services/user.service';
import 'video.js/dist/video-js.css'
import {
    videoPlayer
} from 'vue-video-player'
import UtilService from '../../services/util'
import TeamService from '../../services/team.service'

export default {
    name: "initial-setup",
    components: {
        videoPlayer
    },
    data() {
        return {
            showWelcomeScreen: true,
            showQuestionWelcomeScreen: true,
            showQuestionFinalScreen: false,
            playerOptions: {
                // videojs options
                muted: false,
                language: 'en',
                fluid: true,
                playbackRates: [1],
                techOrder: ['youtube'],
                sources: [],
                poster: "",
                controls: true,
                autoplay: false,
            },
            personalInformation: {
                first_name: '',
                last_name: '',
                date_of_birth: null,
                start_date: null,
                phone_number: '+44',
                gender: '',
                country: '',
                zip_code: '',
                house_number: '',
                street_address: '',
                city: '',
                work_email: '',
                email: '',
                team_leader: '',
                completedTutorial: false,
                completedTutorialQuestions: false,
                completedPersonalInfo: false,
                agreedToJD: false,
                agreedPayment: false,
                agreedNCDStudent: false,
                agreedNCDPersonal: false,
                agreedTermination: false,
                videoStep: 1,
                tutorialMark: -1,
                questionAnswers: [],
                noOfTimesTestTook: 0,
                financial: {
                    national_ins_no: '',
                    uk_settlement_status: '',
                    share_code: '',
                    self_employed: '',
                    utr_no: '',
                    account_name: '',
                    account_no: '',
                    short_code: ''
                },
                completedRegistration: false
            },
            showSidebar: true,
            personalInfoErrors: [],
            showModal: false,
            videoTutorialStep: 0,
            maxStepReached: 0,
            completedVideo: false,
            tutorialStep: 1,
            currentTutorial: {
                step: 0,
                image: '',
                title: '',
                transcript: ''
            },
            tutorialData: [],
            genderOptions: [],
            sidebarTutorialList: [{
                "label": "General Info",
                "order": 3
            }, {
                "label": "Job Description and Responsabilities",
                "order": 4
            }, {
                "label": "Payment",
                "order": 5
            }, {
                "label": "Student personal data",
                "order": 6
            }, {
                "label": "Internal procedures",
                "order": 7
            }, {
                "label": "Terms of Termination",
                "order": 8
            }, {
                "label": "Financial Data",
                "order": 9
            }],
            currentTutorialQuestion: {
                show: false,
                question: null,
                answer: null,
                correctAnswer: null,
                step: 1
            },
            finalQuestions: [],
            serverCompletedTutorial: false
        }
    },
    mounted() {
        UserService.checkUser(this.currentUser.id).then((response) => {
            let showData = false
            if (response.data.length) {
                const userData = JSON.parse(response.data[0].templateOptions)
                this.serverCompletedTutorial = response.data[0].completedTutorial
                showData = userData && ('completedRegistration' in userData) && this.serverCompletedTutorial ? false : true;
            }

            if (!showData) {
                showData = this.userEditingData
            }

            if (showData) {
                this.initialData()
            } else {
                this.logOutFromApp()
            }
        })
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },

        userEditingData() {
            return this.$store.state.auth.userEditingData;
        },

        maxTutorialStepReached() {
            switch (true) {
                case this.personalInformation.agreedTermination === true:
                    return 9;

                case this.personalInformation.agreedNCDPersonal === true:
                    return 8;

                case this.personalInformation.agreedNCDStudent === true:
                    return 7;

                case this.personalInformation.agreedPayment === true:
                    return 6;

                case this.personalInformation.agreedToJD === true:
                    return 5;

                case this.personalInformation.completedPersonalInfo === true:
                    return 4;

                case !this.personalInformation.completedPersonalInfo && this.personalInformation.completedTutorialQuestions:
                    return 3;

                case this.personalInformation.completedTutorial && !this.personalInformation.completedTutorialQuestions:
                    return 2;

                default:
                    return 1;
            }
        },

        modalTitle() {
            return this.tutorialStep === 1 ? 'Training time' : 'Complete your data'
        },

        player() {
            return this.$refs.videoPlayer ? this.$refs.videoPlayer.player : null
        },
    },

    methods: {
        logOutFromApp() {
            this.$buefy.dialog.alert({
                title: 'Session timeout',
                message: 'There seems to be an issue with your login credentials. Please logout and if this persists, contact someone from the support team!',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
                onConfirm: () => this.logOut()
            })
        },

        initialData() {
            this.genderOptions = genderOptions
            this.showModal = true
            this.tutorialData = tutorialData;
            if (this.currentUser.templateOptions && Object.keys(this.currentUser.templateOptions).length) {
                this.personalInformation = {
                    ...this.currentUser.templateOptions,
                    start_date: new Date(this.currentUser.templateOptions.start_date),
                    date_of_birth: new Date(this.currentUser.templateOptions.date_of_birth)
                };

                this.tutorialStep = this.maxTutorialStepReached

                if (this.tutorialStep > 3) {
                    this.showWelcomeScreen = false
                }

                if (this.tutorialStep == 1) {
                    this.setTutorial(this.currentUser.templateOptions.videoStep, true)
                }
            } else {
                this.setTutorial(1, true)
            }

            this.finalQuestions = tutorialQuestions.map((tutorial) => {
                return {
                    ...tutorial,
                    answer: tutorial.type === 'single-select' || tutorial.type === 'multi-select' ? [] : '',
                }
            }).sort(() => .5 - Math.random())

            if (this.player) {
                this.player.controlBar.progressControl.disable();
            }
        },

        askTutorialQuestion(step) {
            const foundTutorial = this.tutorialData.filter(tutorial => tutorial.step === step)

            if (foundTutorial[0].question) {
                this.currentTutorialQuestion = {
                    show: true,
                    question: foundTutorial[0].question,
                    correctAnswer: foundTutorial[0].answer,
                    answer: null,
                    step: step,
                    type: null
                }
            } else {
                this.setTutorial(step + 1, true)
            }
        },

        validateAnswer() {
            if (this.currentTutorialQuestion.answer === null) return
            this.currentTutorialQuestion.type = this.currentTutorialQuestion.answer === this.currentTutorialQuestion.correctAnswer ? 'text-is-success' : 'text-is-danger'
        },

        rewatchVideo() {
            const currentSource = JSON.parse(JSON.stringify(this.playerOptions.sources))

            this.playerOptions.sources = null
            this.playerOptions.sources = currentSource

            this.hideTutorialQuestion()
        },

        hideTutorialQuestion() {
            this.currentTutorialQuestion = {
                show: false,
                question: null,
                correctAnswer: null,
                answer: null,
                step: 1,
                type: null
            }
        },

        setTutorial(step, increaseMax) {
            if (this.maxStepReached < step && !increaseMax) {
                return
            }

            this.hideTutorialQuestion()

            const foundTutorial = this.tutorialData.filter(tutorial => tutorial.step === step)
            if (foundTutorial.length) {
                this.playerOptions.sources = [
                    foundTutorial[0].video
                ]

                this.playerOptions.poster = foundTutorial[0].poster

                this.videoTutorialStep = foundTutorial[0].step

                if (increaseMax) {
                    this.maxStepReached = foundTutorial[0].step
                    this.personalInformation.videoStep = this.maxStepReached
                    this.storeUserData()
                }

                this.currentTutorial = {
                    step: foundTutorial[0].step,
                    image: foundTutorial[0].image,
                    title: foundTutorial[0].title,
                    transcript: foundTutorial[0].transcript,
                }

            } else {
                this.personalInformation.videoStep = this.maxStepReached
                this.personalInformation.completedTutorial = true
                this.tutorialStep = this.maxTutorialStepReached
                this.storeUserData()
            }
        },

        clearDate(date) {
            this.personalInformation[date] = null
        },

        filteredCountries(field) {
            return countryList.filter((option) => {
                return this.personalInformation[field] !== null ? option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.personalInformation[field].toLowerCase()) >= 0 : null
            })
        },

        rewatchTutorials(watchVideos) {
            this.personalInformation.completedTutorial = watchVideos
            this.tutorialStep = this.maxTutorialStepReached
            if (!watchVideos) {
                this.setTutorial(18, true)
            }
        },

        filteredUsers() {
            return UtilService.getTeamLeaders().map(user => user.username).filter((option) => {
                return this.personalInformation.team_leader !== null ? option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.personalInformation.team_leader.toLowerCase()) >= 0 : null
            })
        },

        closedModal() {
            return false
        },

        changeSelectValue(parentIndex, type) {
            if (type === 'single-select') {
                const copyQuestions = [...this.finalQuestions]
                copyQuestions[parentIndex].answer = []

                setTimeout(() => {
                    this.finalQuestions = copyQuestions
                }, 0);
            }
        },

        handleQuestionValidator() {
            this.$validator.validateAll().then(() => {
                const neinNew = this.finalQuestions.map(question => {
                    if (question.type === 'text') {
                        return question.correctAnswer.some(cAnswer => question.answer.toLowerCase().includes(cAnswer))
                    } else if (question.type === 'multi-select') {
                        return question.answer.filter(x => x).sort().toString() == question.correctAnswer.sort().toString()
                    } else if (question.type === 'single-select') {
                        return question.answer.includes(question.correctAnswer)
                    }

                    return question.answer === question.correctAnswer
                })

                const mappedAnswersForSaving = neinNew.map((wasSuccess, index) => {
                    return {
                        wasAnswerCorrect: wasSuccess,
                        question: this.finalQuestions[index].question,
                        answer: this.finalQuestions[index].answer,
                    }
                })

                const finalMark = parseInt((neinNew).filter(x => x).length / this.finalQuestions.length * 100)

                this.personalInformation.tutorialMark = finalMark
                this.showQuestionWelcomeScreen = true
                this.personalInformation.userTestAnswers = mappedAnswersForSaving
                this.personalInformation.noOfTimesTestTook = this.personalInformation.noOfTimesTestTook + 1

                this.storeUserData()
            })
        },

        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
        },

        triggerValidExam() {
            this.personalInformation.completedTutorialQuestions = true
            this.showQuestionWelcomeScreen = false
            this.tutorialStep = this.maxTutorialStepReached
        },

        storeUserData() {
            UserService.updatePersonalInformation({
                id: this.currentUser.id,
                templateOptions: JSON.stringify(this.personalInformation)
            });
            this.$store.dispatch('auth/setUserTemplateOptions', this.personalInformation);
        },

        handlePersonalInfoValidator() {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    for (var i = 0; i < this.errors.items.length; i++) {
                        this.errors.items[i].msg = this.errors.items[i].msg.replaceAll('_', ' ');
                    }

                    return;
                }

                if (this.tutorialStep > 3) {
                    this.personalInformation.completedRegistration = true
                    UserService.agreeToTerms({
                        id: this.currentUser.id
                    }).then(() => {
                        this.$buefy.toast.open({
                            duration: 3000,
                            message: `Completed tutorial`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                    })
                } else {
                    const foundUser = UtilService.getTeamLeaders().filter(team => team.username === this.personalInformation.team_leader)

                    if (foundUser.length) {
                        TeamService.assignTeam({
                            userId: this.currentUser.id,
                            teamId: foundUser[0].team_users[0].teamId
                        })
                    } else {
                        this.$buefy.snackbar.open({
                            message: 'Unable to find Team leader, please contact a moderator to get assigned to a team',
                            type: 'is-danger',
                            position: 'is-top',
                            indefinite: true,
                        })
                    }

                    this.personalInformation.completedPersonalInfo = true
                }

                this.nextAgree()

            })
        },

        nextAgree() {
            this.storeUserData()
            this.tutorialStep++
            const lastTutorialStep = Math.max.apply(Math, this.sidebarTutorialList.map(tutorial => tutorial.order))

            if (this.tutorialStep === lastTutorialStep + 1) {
                this.$router.push('/profile');
            }
        }
    }
}
</script>

<style>
.vjs-progress-control.vjs-control {
    display: none;
}

.modal-card-logo {
    border: 2px solid white;
    border-radius: 50%;
    width: 50px;
    margin-right: 20px;
}

.modal-card-title {
    font-size: 26px;
    font-weight: bold;
}

.welcome-overlay {
    position: absolute;
    z-index: 20;
    background: #2b2a2a;
    width: 100vw;
    left: 0;
    top: 91px;
    height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.welcome-overlay>p {
    font-size: 30px;
    color: white;
}

.welcome-overlay>p b {
    color: #ffc451;
}

.welcome-overlay img {
    max-width: 200px;
    padding-top: 10vh;
}

.welcome-overlay button {
    margin-top: 24px;
    width: 120px;
    font-size: 30px;
}

.tutorial-sidebar {
    z-index: 41;
    position: fixed;
    left: 0;
}

.tutorial-modal-card-body {
    padding-left: 280px;
}

table.payment-table {
    width: 400px;
    max-width: 90vw;
    margin: 20px auto;
    border: 2px solid slategray;
}

table.payment-table thead th {
    border-width: 2px;
    border-color: slategray;
    background: #ffc451;
}

.tutorial-display__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 12px;
}

.checkbox-accept-tutorial {
    margin: 20px 0;
}

.checkbox-accept-tutorial>label.b-checkbox.checkbox {
    font-size: 15px;
    margin-left: 4px;
}

.self-employed-warning>button.delete {
    display: none;
}

.image-background___tutorial {
    min-height: 400px;
    height: 600px;
    background: no-repeat;
    background-size: contain;
}

.text-is-success {
    color: #48c78e;
}

.text-is-danger {
    color: #f14668;
}

.logout-button-setup {
    position: fixed;
    top: 20px;
    right: 20px;
}
</style>
